// extracted by mini-css-extract-plugin
export var notificationHost = "_j4-0";